// src/components/NewMessageForm.js

import React from "react"
import PropTypes from "prop-types"

class NewMessageForm extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      text: ""
    }
  }

  handleChange = (e) => {
    this.setState({ text: e.target.value })
  }

  submitHandler = (e) => {
    e.preventDefault()
    this.props.submitHandler(this.state.text).then(() => {
      this.setState({ text: "" })
    })
  }

  render = () => {
    const { submitHandler, handleChange } = this
    const { text } = this.state

    return (
      <div className="newMessageForm">
        <form onSubmit={submitHandler}>
          <label>New Message:</label>
          <br />
          <input type="text" value={text} onChange={handleChange} />
          <input type="submit" />
        </form>
      </div>
    )
  }
}

NewMessageForm.propTypes = {
  submitHandler: PropTypes.func.isRequired
}

export default NewMessageForm
